import React, { FunctionComponent } from 'react';

type Props = {
	loading: boolean;
	children: any;
};
export const LoadingOverlayComponent: FunctionComponent<Props> = ({ loading, children }) => {
	return <div className={`${loading ? 'loading-overlay' : ''}`}>{children}</div>;
};
